import * as R from 'ramda';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import { IFRAME_EVENT_MESSAGE } from '@/utils/consts';
import { BUSINESS_PAGES } from '@consts';
import { debounce } from 'lodash';

export default {
    data() {
        return {
            iframeListeners_: [
                {
                    eventType:
                        IFRAME_EVENT_MESSAGE.CLICK_COPY_CONNECTION_SHARE_LINK,
                    listener: (event) => {
                        const params = {
                            params: { id: event.data.viewId },
                            query: R.path(['$route', 'query'], this),
                        };

                        this.$router.replace(params);
                    },
                },
                // Notification messages
                {
                    eventType: IFRAME_EVENT_MESSAGE.ADD_NOTI_MSGS,
                    listener: (event) => {
                        if (this.isMobileSize && !event.data.mobileVisible)
                            return;
                        this.addNotiMsg(event.data);
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.SET_NOTI_MSGS,
                    listener: (event) => {
                        const visibleData = event.data?.filter(
                            ({ mobileVisible }) => mobileVisible
                        );
                        const data = this.isMobileSize
                            ? visibleData
                            : event.data;
                        this.setNotiMsgs(data || []);
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.REMOVE_NOTI_MSG,
                    listener: (event) => {
                        this.removeNotiMsg(event.data);
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.SET_TOAST_MSG,
                    listener: (event) => {
                        if (this.isMobileSize && !event.data.mobileVisible)
                            return;

                        this.setToast(event.data);
                    },
                },
                // router
                {
                    eventType:
                        IFRAME_EVENT_MESSAGE.OPEN_NEW_WINDOW_WITH_FILTERS,
                    listener: (event) => {
                        const groupFilters = R.pathOr(
                            [],
                            ['data', 'groupFilters'],
                            event
                        );

                        const { href } = this.$router.resolve({
                            query: R.assoc(
                                'groupFilters',
                                JSON.stringify(groupFilters),
                                this.$route.query
                            ),
                        });
                        href && window.open(href, '_blank');
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.SYNC_ROUTE,
                    listener: debounce((event) => {
                        const { query = {} } = event?.data;

                        const viewId = R.pathOr(null, ['viewId'], query);
                        const refinedQuery = R.omit(
                            [
                                'viewId',
                                'locale',
                                'country',
                                'baseUrl',
                                'userAccountId',
                                'accountId',
                            ],
                            query
                        );

                        if (viewId) {
                            this.$router.replace({
                                name: 'Dashboard',
                                params: { id: viewId },
                                query: refinedQuery
                                    ? { ...refinedQuery, update: true }
                                    : { update: true },
                            });
                        }
                    }, 200),
                },
                // GNB
                {
                    eventType: IFRAME_EVENT_MESSAGE.PUSH_TO_ROUTE,
                    listener: (event) => {
                        if (event?.data?.route) {
                            const { route } = event.data;
                            if (route === 'logo') {
                                if (
                                    this.$route.name
                                        .toLowerCase()
                                        .includes('sign')
                                ) {
                                    window.location.href =
                                        this.language === 'ko'
                                            ? BUSINESS_PAGES.kr
                                            : BUSINESS_PAGES.en;
                                } else {
                                    this.pushToRoute({
                                        name: this.isPlanT
                                            ? 'Dashboard'
                                            : 'MyCampaigns',
                                    });
                                }
                            } else if (route === 'new_campaign') {
                                //TODO: add Select new_campagin (when is korean)
                                this.setIsNewCampaignModalActive(true);
                                return;
                            } else {
                                this.pushToRoute(route);
                            }
                        }
                    },
                },
                // Handle back navigation with fallback
                {
                    eventType: IFRAME_EVENT_MESSAGE.ROUTER_BACK,
                    listener: (event) => {
                        if (window.history.length > 1) {
                            this.$router.back();
                        } else if (event?.data?.fallbackRouteName) {
                            this.$router.push({
                                name: event.data.fallbackRouteName,
                            });
                        }
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.CHANGE_ACCOUNT,
                    listener: (event) => {
                        if (event?.data?.id) {
                            this.changeAccount(
                                event.data.id,
                                this.$route.meta?.canChangeAccount ?? false
                            );
                        }
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.SHOW_LOGOUT_MODAL,
                    listener: () => {
                        this.setLogoutModalActive(true);
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.USER_DEACTIVATED,
                    listener: () => {
                        const lang = this.user?.language;
                        this.logout().finally(() => {
                            this.$router.push({
                                name: 'Sign/Login',
                                query: {
                                    lang: lang || 'en',
                                },
                            });
                        });
                    },
                },

                // Sync Account
                {
                    eventType: IFRAME_EVENT_MESSAGE.PAGE_LOAD_EVENT,
                    listener: () => {
                        if (this.account) {
                            this.postIframeMessage({
                                type: `SYNC_ACCOUNT`,
                                origin: `VUE`,
                                data: {
                                    account: this.account,
                                },
                            });
                        }

                        if (this.user) {
                            this.postIframeMessage({
                                type: `SYNC_USER`,
                                origin: `VUE`,
                                data: {
                                    user: this.user,
                                },
                            });
                        }
                        if (this.chatUnreadCnt) {
                            this.postIframeMessage({
                                type: `CHAT_UNREAD_CNT_UPDATED`,
                                origin: `VUE`,
                                data: {
                                    chatUnreadCnt: this.chatUnreadCnt,
                                },
                            });
                        }

                    },
                },
                // move to other page
                {
                    eventType: IFRAME_EVENT_MESSAGE.MOVE_TO_OTHER_PAGE,
                    listener: (event) => {
                        const { params } = event.data || {};

                        const { name, additionalQuery = {} } = params;

                        const { query = {} } = this.$route;

                        this.$router.push({
                            name,
                            query: { ...query, ...additionalQuery },
                        });
                    },
                },
                // lite version
                {
                    eventType: IFRAME_EVENT_MESSAGE.RENDER_LITE_VERSION_DIALOG,
                    listener: () => {
                        this.renderWarningToLimiedUser();
                    },
                },
                // reload with noCache=1
                {
                    eventType: IFRAME_EVENT_MESSAGE.RELOAD_WITH_NO_CACHE,
                    listener: () => {
                        let href = window.location.href;
                        if (!href.includes('noCache')) {
                            href += '&noCache=1';
                        }

                        window.location.href = href;
                        window.location.reload();
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.ACTIVATE_WINDOW_SCROLL,
                    listener: () => {
                        document
                            .querySelector('html')
                            .classList.remove('overflow-hidden');
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.UPDATE_SNACKBAR_SAFE_BOTTOM,
                    listener: (event) => {
                        if (event?.data?.value !== undefined) {
                            this.setSnackbarSafeBottom(event.data.value);
                        }
                    },
                },
            ],
        };
    },
    computed: {
        ...mapGetters('user', [
            'isAdmin',
            'userId',
            'planType',
            'userLang',
            'user',
            'account',
            'accountToken',
        ]),
    },
    methods: {
        ...mapMutations('view', [
            'addNotiMsg',
            'setNotiMsgs',
            'removeNotiMsg',
            'setIsNewCampaignModalActive',
            'setLogoutModalActive',
            'setSnackbarSafeBottom',
        ]),
        ...mapActions('iframe', ['postIframeMessage']),
        ...mapActions('user', ['logout']),

        addIframeCommonListeners() {},
    },
    mounted() {
        this.$nextTick(() => {});
    },
    beforeDestroy() {
        // Reset offset set via UPDATE_SNACKBAR_SAFE_BOTTOM so it doesn't
        // leak into the next page and push toasts off their default spot.
        this.setSnackbarSafeBottom(null);
    },
};
